// Modules
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select/lib/Select';
// Constants
import CountriesService from '../../../services/CountriesService';
// Styles
import * as styles from './PublishFormLocationInput.scss';

class PublishFormCountriesSelect extends Component {
  state = {
    inputValue: ''
  };

  checkMatches = (option, lang, input) => {
    const text = input || '';
    const words = text.split(' ');
    return words.reduce(
      (acc, cur) => acc && option[lang].toLowerCase().includes(cur.toLowerCase()),
      true,
    );
  }

  handleInputChange = (inputValue) => {
    this.setState({ inputValue });
    return inputValue;
  };

  handleChange = (selectedOption) => {
    this.props.onChangeCountry(selectedOption);
    this.setState({ inputValue: selectedOption ? selectedOption.label : '' });
  }

  highlightedOption = (option) => {
    const input = this.state.inputValue;
    const regex = new RegExp(`(${input})`, 'i');
    const isMatch = (lang) => this.checkMatches(option, lang, input);
    let searchKey = option.label;
    if (isMatch('en')) {
      searchKey = option.en;
    } else if (isMatch('he')) {
      searchKey = option.he;
    } else if (isMatch('ru')) {
      searchKey = option.ru;
    }

    if (input) {
      const parts = searchKey.split(regex).map((p, i) => {
        const id = i;
        return regex.test(p) ? (<strong key={`part_${p}${id}`}>{p}</strong>) : p;
      });
      return (<div className={styles.selectOption}>{parts}</div>);
    }
    return (
      <div className={styles.selectOption}>{option.label}</div>
    );
  };

  filterOption = (option, inputValue) => {
    const isMatch = (lang) => this.checkMatches(option, lang, inputValue);
    return isMatch('en') || isMatch('he') || isMatch('ru');
  };

  formatCountriesOptions = () => {
    const { locale } = this.props;
    const countries = CountriesService.get();

    if (!countries) return [];

    return countries.map(option => ({
      key: option.id,
      id: option.id,
      value: locale === 'he' ? option.address[locale] : option.address.en,
      label: locale === 'he' ? option.address[locale] : option.address.en,
      en: option.address.en,
      he: option.address.he,
      ru: option.address.ru
    }));
  }

  render() {
    const { address, country_name, translate, isRtl, onChangeCountry, locale } = this.props;
    const countryValue = address.country_name || '';

    return (
      <div className={styles.countriesWrap}>
        <Select
          name="address.country_name"
          searchable
          clearable
          value={countryValue}
          options={this.formatCountriesOptions()}
          optionRenderer={this.highlightedOption}
          filterOption={this.filterOption}
          onChange={this.handleChange}
          onInputChange={this.handleInputChange}
          instanceId="publish_country"
          rtl={isRtl}
          placeholder={translate('country').toString()}
          noResultsText={translate('noResultsTitle').toString()}
        />
      </div>
    );
  }
}

PublishFormCountriesSelect.propTypes = {
  locale: PropTypes.string,
  address: PropTypes.object,
  country_name: PropTypes.string,
  isRtl: PropTypes.bool,
  translate: PropTypes.func,
  onChangeCountry: PropTypes.func
};

export default PublishFormCountriesSelect;
